(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Content', function($stateParams) {
        return {
            _cssForContractors: {
                all: []
            },
            getPathForContractor: function() {
                if (_.contains(['eo', 'giek', 'pgeo', 'pged'], $stateParams.contractor)) {
                    return $stateParams.contractor;
                }

                return 'all';
            },
            getContractorCss: function() {
                return this._cssForContractors[this.getPathForContractor()];
            },
            getCommodity: function(commodity) {
                var commodityName = commodity;
                if (commodityName === 'other') {
                    commodityName = 'others';
                }
                if (_.contains(['energy', 'gas', 'others'], commodityName)) {
                    return commodityName;
                }

                return 'energy';
            },
            getCommodityEnum: function(commodity) {
                var commodityName = commodity;
                if (commodityName === 'others') {
                    commodityName = 'other';
                }
                if (_.contains(['energy', 'gas', 'other'], commodityName)) {
                    return commodityName;
                }

                return 'energy';
            },
            _getControllerPrefix: function(commodity) {
                var commodity = this.getCommodity(commodity);
                var controllerPrefix = commodity.charAt(0).toUpperCase() + commodity.slice(1);
                return controllerPrefix;
            },
            getEventController: function(commodity) {
                return this._getControllerPrefix(commodity) + 'EventController';
            },
            getEventDetailController: function(commodity) {
                return this._getControllerPrefix(commodity) + 'EventDetailController';
            }
        };
    });
})();
